import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupJnsClubPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/jns/club-points.hbs" })